import { render, staticRenderFns } from "./Yljg.vue?vue&type=template&id=786b0e30&"
import script from "./Yljg.vue?vue&type=script&lang=ts&"
export * from "./Yljg.vue?vue&type=script&lang=ts&"
import style0 from "./Yljg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports